import React, { FC } from 'react'

import { locale } from '../locales/locale'
import { useAppSelector } from '../redux/hooks'
import { PrivacyMessageContainer } from './customComponents'

const PrivacyMessage: FC = () => {
    const realm = useAppSelector((state) => state.realm.value)
    return (
        <PrivacyMessageContainer>
            {realm === 'fic' ? (
                <>
                {locale('Fatture in Cloud') + ' ' + locale('è finalizzato a consentire il trattamento dei Dati Personali strettamente necessari ai fini della gestione degli adempimenti') + ' ' + locale('contabili e amministrativi relativi alle fatture elettroniche.') + ' ' + locale('Tale trattamento richiede che') + ' ' + locale('Fatture in Cloud') + ' ' + locale('sia utilizzato in conformità con i principi di minimizzazione, integrità e riservatezza previsti dalla normativa in materia di protezione dei dati personali applicabile') + ', ' + locale('ad esempio limitando la descrizione della prestazione professionale svolta a quanto strettamente necessario a fini fiscali per evitare di includere dati di minori o relativi a prestazioni sanitarie, condanne penali e reati')}
                </>
            ) : (
                <>
                {locale('Dipendenti in Cloud') + ' ' + locale('è finalizzato a consentire il trattamento dei Dati Personali strettamente necessari ai fini della gestione degli adempimenti') + ' ' + locale('relativi alla gestione dei dipendenti.') + ' ' + locale('Tale trattamento richiede che') + ' ' + locale('Dipendenti in Cloud') + ' ' + locale('sia utilizzato in conformità con i principi di minimizzazione, integrità e riservatezza previsti dalla normativa in materia di protezione dei dati personali applicabile')}
                </>
            )}
        </PrivacyMessageContainer>
    )
}

export default PrivacyMessage